module.exports = __webpack_public_path__ + "img/procreate-tablet_cn.3e00f22.jpg";